var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-progress-linear',{staticClass:"mt-10",attrs:{"size":70,"width":7,"color":"purple","indeterminate":""}}):_vm._e(),_c(_vm.dashboardComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }